import {Socket} from "@/services/websocket-api/websocket";

const proWebSocketInstance = {
    install: (Vue:any,options:object) => {
        Vue.prototype.$websocket = Socket.instance;
    }
}

export default proWebSocketInstance;